import React, { createContext, useContext } from 'react';
import { useClassroom } from '../hooks/useClassroom';

const ClassroomContext = createContext(null);

export const ClassroomProvider = ({ accessToken, children }) => {
    const classroom = useClassroom(accessToken);

    return (
        <ClassroomContext.Provider value={classroom}>
            {children}
        </ClassroomContext.Provider>
    );
};

export const useClassroomContext = () => {
    const context = useContext(ClassroomContext);

    if (!context) {
        throw new Error(
            "useClassroomContext must be used inside a ClassroomProvider"
        );
    }

    return context;
};